import type { Plugin } from 'vue'
import { routeNames } from '@/router/route-names'
import { portalNames } from './portal.plugin'
import { twMerge } from 'tailwind-merge'
import { filters } from '@/core/filters'
import { useModals } from '@/composables/modals'
import { useAllowedForRole } from '@/composables/allowed-fo-role'

export const globalProperties = {
  $routeNames: routeNames,
  $portalNames: portalNames,
  $filters: filters,
  $twMerge: twMerge,
  $modals: useModals(),
  $isAllowedForRole: useAllowedForRole
}

export const VueGlobalPropertiesPlugin: Plugin = {
  install: (app) => {
    for (const i in globalProperties) {
      app.config.globalProperties[i] = globalProperties[i as keyof typeof globalProperties]
    }
  }
}
